module.exports = __webpack_public_path__ + "img/weapons3new.2b2660fa.jpg";